export default {
  'm': {
    'uploading': 'Uploading...',
    'upload_failed': 'Upload failed',
    'EnterID': 'Click to enter BuzzCast ID',
    'select-specifications': 'Click to select recharge specifications',
    'check-account': 'Check the recharge account',
    'whatID': 'What is BuzzCast ID?',
    'getID': 'Enter BuzzCast ID',
    'maskgetID': 'Enter BuzzCast ID',
    'toastTips-format-error': 'Input format is incorrect',
    'toastTips-no-exist': 'The ID does not exist',
    'toastTipsPlease': 'Please check the recharge account first',
    'common-problem': 'Common problem',
    'transaction-succeeded': 'Transaction succeeded',
    'transaction-failed': 'Transaction failed',
    'transaction-cancel': 'Transaction cancelled',
    'whether-account': '1. How to check whether the account is received after I recharge?',
    'answer-whether-account': 'After recharging, you can return to the app\'s [My]-[Wallet] to view diamonds',
    'no-account': '2.What if I don\'t get the account after recharge?',
    'answer-no-account': 'Please submit your questions in [Message]-[Official News]-[Feedback and Help] of the app, and provide the following information, our customer service will help you.',
    'recharge-money': '1. Recharge amount and account ID',
    'recharge-time': '2. Recharge time and date',
    'recharge-shot': '3. Screenshot of successful payment',
    'recharge-wrong': '3.What should I do if I charge the wrong account and the wrong amount',
    'answer-recharge-wrong': 'Before entering the payment password, please make sure to carefully confirm the recharge account ID and recharge amount information to make a purchase. The amount of the wrong charge cannot be refunded. For the wrong charge account, you can try to contact the ID user who you actually recharged, and negotiate with the other party if they are willing to compensate your recharge',
    'refund': '4.Refund',
    'answer-refund': 'Sorry! BuzzCast currently does not support any form of refund.',
    'buy-enter-link': 'Purchase diamonds can be recharged through the link, <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> Copy the link in the mobile browser to open, enter the purchase page, after checking the account, select the corresponding specifications and use the appropriate payment method to pay~ Lots of discounts!',
    'buy-notice-a': 'Note: <a>{msg}</a> is the only official diamond purchase website for BuzzCast',
    'replace': 'Change',
    'sureBtn': 'Confirm',
    'pay-style': 'Choose payment method',
    'goBack': 'Back to the homepage',
    'toastTips': 'Enter BuzzCast ID',
    'rechargeFAQ_title': 'Common problem',
    'PayStatusSuccess_title': 'Transaction succeeded',
    'PayStatusFail_title': 'Transaction failed',
    'PayStatusCancel_title': 'Transaction cancelled',
    'Diamonds_title': '{msg} Diamond Recharge Official Website',
    'buy-notice': 'Note pay.buzzcast.info is BuzzCast\'s only official diamond-purchasing website, For customer service inquiries, please enter [Message]-[Official News]-[Feedback and Help]',
    'RechargeHelp_title': 'Recharge Help',
    'RechargeProblem_title': 'Your recharge encountered a problem,',
    'feedback_and_help': 'Feedback and Help',
    'problem_screenshot': 'Problem screenshot / screen recording ({msg})',
    'problem_description': 'Problem description',
    'problem_description_placeholder': 'Please describe the problem you have',
    'optional': 'optional',
    'required': 'required',
    'openAPP': 'Open BuzzCast APP',
    'buy-diamonds-tit': 'Purchasing Diamond Service',
    'description': 'BuzzCast is the only official diamond recharge site, BuzzCast is an international social software, there are more than 150 countries and regions around the world are using BuzzCast',
    'keywords': 'BuzzCast recharge, BuzzCast diamond recharge, BuzzCast official recharge, BuzzCast official recharge website',
    'payforType': 'Recharge method',
    'trueText': 'Confirm',
    'falseText': 'Cancel',
    'alertShowTxt1': 'Are you sure to use',
    'alertShowTxt3': 'to recharge',
    'alertShowTxt5': 'diamonds?',
    'EnterIDTip': '{msg} quick recharge',
    'scanLogin': 'For account privacy and security, please scan the code to log in.',
    'scanTip': 'Ti: Click on the top right corner of the BuzzCast "Personal Center/Dynamics" and "scan".Scan code login,and support the identification of two - dimensional code screenshots login.',
    'scanVersion': 'Please upgrade BuzzCast to the %s version and scan the code to log in',
    'delAccount': 'Delete account',
    'logout': 'Sign out',
    'submit': 'Submit',
    'email_place_holder': 'Please enter your email address',
    'fill_in_email_address': 'Please fill in the email address',
    'fill_in_all_required': 'Please enter the problem description',
    'order_exception_notice': 'Friendly reminder: if the recharge order is abnormal, you have to provide the order number or payment screenshot',
    'cannot_read_file': 'Unable to read file',
    'upload_file_exceed_limit': 'The uploaded file cannot exceed {num} MB',
    'submitting': 'Submitting...',
    'submit_failed': 'Submission failed',
    'contact_email': 'Contact E-mail',
    'provide_email': 'Please provide your E-maii address for payment order',
    'email_address': 'E-mail Addrerss',
    'sel_country_area': 'Select Country or Region',
    'search_for': 'Search',
    'login': 'Login',
    'scan_login': 'Scan the code to login',
    'account_password_error': 'Incorrect Phone Number or Password',
    'user_frozen': 'The user has been frozen',
    'account_no_reg': 'The account is not registered till now',
    'login_no': 'You are still not logged in yet',
    'login_after_recharge': 'You can recharge after logging in',
    'scan_login_lesson': 'The instruction of QR code to log in',
    'scan_login_desc': 'The QR code login method can quickly and securely enter the Top-up page. The following two methods will introduce how to scan the code to log in.',
    'scan_login_a_title': 'Log in by scanning screenshots of QR codes',
    'scan_login_a_p1': '1. It is more suitable for users to use a single device to enter the Top-up page, Click to select "Scan code login", take a screenshot of the page with the login QR code, and save it into your album. (The screenshot function is slightly different for different devices, please search how to take a screenshot on your own phone)',
    'scan_login_a_p2': '2. Open the BuzzCast APP, go to the "Personal Center" or "Post" page, and click "Scan" in the upper right corner to scan the QR code.',
    'scan_login_a_p3': '3. Click "Album selection" and allow album permissions, select the saved QR code login page screenshot, click the "Login" confirmation button after the system recognizes, switch back to the browser and wait for a while, the page will automatically load user information.',
    'scan_login_b_title': 'Scan QR code to log in',
    'scan_login_b_p1': '1. It is more suitable for the use of multiple devices. The user enters the login page of the recharge website, and click "Scan Code Login".',
    'scan_login_b_p2': '2. Open the BuzzCast App on another device, and click "scan" on the upper right corner to enter the code scanning function module through the "Personal Center" or "Dynamic" function module.',
    'scan_login_b_p3': '3. Aimed the scanning box at the QR code of the scanning login page, and clicked the "Login" button after the system recognition (it is recommended to keep a certain distance between devices during the scanning to facilitate the system identification). After a short wait, the page will automatically load the user information.',
    'scan_login_lesson_end': 'The above is to scan the code login tutorial guide, I hope to help you.For customer service consultation, please enter APP terminal message - official news - feedback and help.',
    'or': 'Or',
    'input_phone_num': 'Please enter mobile phone number',
    'input_email': 'Please enter your email address',
    'input_password': 'Enter Password',
    'log_in_using_Facebook': 'Log in with Facebook',
    'log_in_using_Google': 'Log in with Google',
    'account_or_pwd_error': 'Incorrect account or password',
    'login_error_relogin': 'Log abnormal, please log in again after the app end in this manner, then return to the page login',
    'pay_fail_system_risk': 'Transaction failed: system abnormal',
    'recharge_fail_risk_network': 'Recharge failed. You may be in a high-risk network environment or for other reasons. If you need help with recharge, please report your issue to us.',
    'friendly_tip': 'Friendly Tips',
    'i_got_it': 'I got it',
    'android_fblogin_tip': 'Because Facebook no longer supports authentication login on the Android embedded browser, you may not be able to log in when you log in this way. If you encounter this type of log-in problem, please use the Chrome browser to access it.',
    'recharge_tip': 'The specific number of diamonds that reach the account is subject to the actual amount of recharge.',
    'sys_error': 'The number of participants is large, please try again later',
    'charge': 'Recharge',
    'link_add_mainpage': 'Add the link to the home screen for the next recharge',
    'click_me_to_add': 'Click me to add',
    'reg_success_go_app': 'Register successfully, please download the app and login to make more friends',
    'user_has_delete': 'This user has been cancelled',
    'sel_one_account': 'Please select the account you want to log in',
    'auth_beoverdue_relogin': 'The session has expired, please log in again',
    'support_contant_whatsapp': 'If you need support, please contact customer service on {msg} App：1924383',
    'buy_balance': 'Purchasable Balance:',
    'official_coin_seller': 'Official Coin Merchant',
    'paystyle_unavailabel_change_other': 'The system is abnormal, this payment method is temporarily unavailable, you can change to other payment methods.',
    'failedPay': 'Payment encountered an issue, please make a new payment',
    "copied": "Copied",
    "reseller": "Reseller",
    "netword_busy_try": "The network is busy, please try again",
    "placecommen": 'Enter search words',
    "app_all_v2": 'All',

		"use_phone_login": `Log in with Phone`,
    "use_email_login": `Log in with Email`,
    "device_is_more": "The number of registered accounts for this device has reached the upper limit",
    "Operation_failed": "This device has been permanently frozen due to account violations",
    "connection_fail_retry_feedback": "Connection failed. Please ensure the network is smooth and try again. If you still encounter errors, please report them to us, and we will resolve them for you as soon as possible.",
    "fawry_recharge_failed": "The ${msg} recharge via {method} was not successful.",
    "feedback": "Feedback",
    "problem_feedback": "Feedback",
    "recommended_recharge_methods": "Recommended payment methods",
    "try_recharge_methods": "Please try to recharge using the following methods. If you still encounter issues, click the \"{feedback}\" button below to contact us.",
    "unable_recharge": "Unable to recharge",
    "submitted_successfully": "Submitted successfully",
    "feedback_success_tip": "Thank you for your feedback, we will deal with it as soon as possible within 24 hours",
    "completed": "Complete",
    "pay_failed": "Payment failed",
    'contact_information': 'Contact information (optional)',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js